import i18n from './i18n'

// use typed 'translate' function instead of i18n.t
export {translate} from './translate'
// eslint-disable-next-line
export type {TKey} from './translations'

export default i18n
